// Copyright (c) 2020 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file wisetime/account/user/v4/user.proto (package wisetime.account.user.v4, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { SiteRef } from "../../../type/site_ref_pb";
import { file_wisetime_type_site_ref } from "../../../type/site_ref_pb";
import type { ServiceAddOns } from "../../../type/addons_pb";
import { file_wisetime_type_addons } from "../../../type/addons_pb";
import { file_google_api_annotations } from "../../../../google/api/annotations_pb";
import type { DataRetentionPeriod } from "../../../type/data_retention_pb";
import { file_wisetime_type_data_retention } from "../../../type/data_retention_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wisetime/account/user/v4/user.proto.
 */
export const file_wisetime_account_user_v4_user: GenFile = /*@__PURE__*/
  fileDesc("CiN3aXNldGltZS9hY2NvdW50L3VzZXIvdjQvdXNlci5wcm90bxIYd2lzZXRpbWUuYWNjb3VudC51c2VyLnY0Ig8KDVdob0FtSVJlcXVlc3QilgMKBFVzZXISCgoCaWQYASABKAkSEgoKZmlyc3RfbmFtZRgCIAEoCRIRCglsYXN0X25hbWUYAyABKAkSDQoFZW1haWwYBSABKAkSEQoJcGhvdG9fdXJsGAYgASgJEhQKDGNvdW50cnlfY29kZRgHIAEoCRIQCgh0aW1lem9uZRgIIAEoCRIsCgxwcml2YXRlX3NpdGUYCSABKAsyFi53aXNldGltZS50eXBlLlNpdGVSZWYSKgoKdGVhbV9zaXRlcxgKIAMoCzIWLndpc2V0aW1lLnR5cGUuU2l0ZVJlZhJKCh5yZXNvbHZlZF9kYXRhX3JldGVudGlvbl9wZXJpb2QYCyABKA4yIi53aXNldGltZS50eXBlLkRhdGFSZXRlbnRpb25QZXJpb2QSHgoRbWF4X3Jvd3NfcGVyX2hvdXIYDCABKA1IAIgBARI1Cg9zZXJ2aWNlX2FkZF9vbnMYDSABKAsyHC53aXNldGltZS50eXBlLlNlcnZpY2VBZGRPbnNCFAoSX21heF9yb3dzX3Blcl9ob3VyMoYBCgtVc2VyU2VydmljZRJ3CgZXaG9BbUkSJy53aXNldGltZS5hY2NvdW50LnVzZXIudjQuV2hvQW1JUmVxdWVzdBoeLndpc2V0aW1lLmFjY291bnQudXNlci52NC5Vc2VyIiSC0+STAh4SHC9hcGkvdjQvYWNjb3VudC91c2Vycy93aG9hbWlCNgogY29tLndpc2V0aW1lLmFwaS5hY2NvdW50LnVzZXIudjRCEFVzZXJTZXJ2aWNlUHJvdG9QAWIGcHJvdG8z", [file_wisetime_type_site_ref, file_wisetime_type_addons, file_google_api_annotations, file_wisetime_type_data_retention]);

/**
 * The current user is identified by the ID token in the Authorization header.
 *
 * @generated from message wisetime.account.user.v4.WhoAmIRequest
 */
export type WhoAmIRequest = Message<"wisetime.account.user.v4.WhoAmIRequest"> & {
};

/**
 * Describes the message wisetime.account.user.v4.WhoAmIRequest.
 * Use `create(WhoAmIRequestSchema)` to create a new message.
 */
export const WhoAmIRequestSchema: GenMessage<WhoAmIRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_account_user_v4_user, 0);

/**
 * @generated from message wisetime.account.user.v4.User
 */
export type User = Message<"wisetime.account.user.v4.User"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string first_name = 2;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 3;
   */
  lastName: string;

  /**
   * @generated from field: string email = 5;
   */
  email: string;

  /**
   * @generated from field: string photo_url = 6;
   */
  photoUrl: string;

  /**
   * @generated from field: string country_code = 7;
   */
  countryCode: string;

  /**
   * Timezone name or value "Autodetect".
   *
   * @generated from field: string timezone = 8;
   */
  timezone: string;

  /**
   * The site where the user's private data is hosted.
   * We currently only use the main wisetime.com site for private user data.
   * This field will always be empty until we add more private user sites.
   *
   * @generated from field: wisetime.type.SiteRef private_site = 9;
   */
  privateSite?: SiteRef;

  /**
   * Team destination sites to which the user is a member of.
   *
   * @generated from field: repeated wisetime.type.SiteRef team_sites = 10;
   */
  teamSites: SiteRef[];

  /**
   * Effective user's data retention. If user's preference is MAX_ELIGIBLE
   * then resolved_data_retention_period is set to evaluated value based on users' memberships,
   * otherwise resolved_data_retention_period is same as preferences.
   *
   * @generated from field: wisetime.type.DataRetentionPeriod resolved_data_retention_period = 11;
   */
  resolvedDataRetentionPeriod: DataRetentionPeriod;

  /**
   * if unset, using default; if set, maximum rows per hour, in range 10-25 inclusive
   *
   * @generated from field: optional uint32 max_rows_per_hour = 12;
   */
  maxRowsPerHour?: number;

  /**
   * @generated from field: wisetime.type.ServiceAddOns service_add_ons = 13;
   */
  serviceAddOns?: ServiceAddOns;
};

/**
 * Describes the message wisetime.account.user.v4.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_wisetime_account_user_v4_user, 1);

/**
 * Resources of the User service API include:
 *
 * - users/*
 *
 *
 * @generated from service wisetime.account.user.v4.UserService
 */
export const UserService: GenService<{
  /**
   * Get the currently logged in user, identified by the ID token in the Authorization
   * header of the request.
   *
   * Possible failure states:
   *
   * NOT_FOUND:       If the user does not exist
   * UNAUTHENTICATED: If the request does not contain a valid ID token
   *
   * @generated from rpc wisetime.account.user.v4.UserService.WhoAmI
   */
  whoAmI: {
    methodKind: "unary";
    input: typeof WhoAmIRequestSchema;
    output: typeof UserSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_wisetime_account_user_v4_user, 0);

